import { currentCityCheck } from './currentCityCheck.js';

function init() {
    currentCityCheck();
}

export {
    init   
}